import { render, staticRenderFns } from "./UserTableMenu.vue?vue&type=template&id=3a6b84b4&lang=pug&"
import script from "./UserTableMenu.vue?vue&type=script&lang=js&"
export * from "./UserTableMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserTableMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports